import Application from './application';
(function() {
  // your page initialization code here
  // the DOM will be available here

  if (__DEV__) {
    console.log('DEVELOPMENT ENVIRONMENT');
  }
  if (__SRC__) {
    console.log('SOURCE ENVIRONMENT');
  }
  if (__DIST__) {
    console.log('DISTRIBUTION ENVIRONMENT');
  }

  try {

    window.scrollTo({top: 0});
    document.body.style.overflowY = "hidden";

    gsap.registerPlugin(ScrollTrigger);
    gsap.registerPlugin(DrawSVGPlugin);

    window.bp3Application = new Application();
    window.bp3Application.initialize();
    // console.log('application is ', window.bp3Application);

  } catch (e) {
    console.log('Caught Error: ', e);
  } finally {
    document.body.style.opacity = '1';
  }

})();
